<script lang="ts">
  import {createEventDispatcher, onMount} from 'svelte';
  import {fly} from 'svelte/transition';
  import {createPopper} from '@popperjs/core';
  import type {Placement, Modifier} from '@popperjs/core';

  let className = '';
  export {className as class};
  export let debug = false;
  // slot trigger 的自定义 class
  export let triggerClass = '';
  // 悬停位置
  export let placement: Placement = 'bottom';
  // trigger 是否显示下拉三角
  export let noIcon = false;
  // 防止抖动
  export let width = 'unset';
  export let trigger: 'hover' = 'hover';
  export let modifiers: Modifier[] = [];
  export let duration = 250
  // trigger 文字和下拉 icon，交互颜色组
  export let color = '#000';
  export let hoverColor = '#3d7eff';
  export let hoverBGColor = 'transparent';

  const dispatch = createEventDispatcher();

  let active = false;
  let tooltipNode;
  let anchorNode;
  let showChildMenu = false;
  let placeHeight = 0;

  onMount(() => {
    // welcome Alert会有展示动画
    let timer = setTimeout(() => {
      const welComeAlertDom = document.querySelector('.newbie-rewards-alert');
      if (welComeAlertDom) {
        placeHeight = welComeAlertDom.clientHeight;
      }
      clearTimeout(timer);
    }, 1000);
  });

  function createTip() {
    createPopper(anchorNode, tooltipNode, {
      placement,
      modifiers,
    });
  }

  function handleMouseEnter() {
    active = true;
    createTip();
    dispatch('mouseenter');
  }

  function handleMouseLeave() {
    if (showChildMenu) {
      return;
    }
    active = false;
    dispatch('mouseleave');
  }

  function handleSecondMenuVisible(v) {
    showChildMenu = v;
  }
</script>

<style lang="scss">
  .tooltip-container {
    z-index: 9999;
    pointer-events: auto;
  }
  .auto-scroll {
    border-radius: 12px;
    overflow-y: auto;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  }
  .drop-arrow {
    position: relative;
    top: 1px;
    transition: all 0.2s;
  }
  .tooltip-trigger {
    color: var(--color);
  }
  .tooltip-wrap:hover .tooltip-trigger {
    background-color: var(--hoverBGColor);
    color: var(--hoverColor);
  }
  .tooltip-wrap:hover .drop-arrow {
    transform: rotate(180deg);
  }
</style>

<div class="tooltip-wrap dib df aic jcsb {className}" style="--hoverColor: {hoverColor}; --color: {color}; --hoverBGColor: {hoverBGColor}" on:mouseleave={handleMouseLeave}>
  <div bind:this={anchorNode} class="tooltip-trigger df aic jcsb cp {triggerClass}" on:mouseenter={handleMouseEnter}>
    <slot name="trigger" />
    {#if !noIcon}<i class="iconfont drop-arrow dib ml4 f12">&#xe756;</i>{/if}
  </div>

  <div class="tooltip-container pa {className}" style="width: {width}" bind:this={tooltipNode} role="tooltip">
    {#if active || debug}
      <div class="auto-scroll sv" style={`max-height: calc(100vh - ${84 + placeHeight}px)`} in:fly={{duration, y: 30}} out:fly={{duration, y: 30}}>
        <slot name="dropdown" showChildMenu={handleSecondMenuVisible} />
        <slot />
      </div>
    {/if}
  </div>
</div>
